import React, { useEffect, useState } from "react";
import moment from "moment";
import styled from '@emotion/styled'
import { Row, Col, Accordion, Card, Button, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faMapPin, faComment, faCheck, faTimes, faCaretUp, faCaretDown, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import { Link, useLocation } from "react-router-dom";
import { isUnusualRecoveryDate } from "helper/globalHelper";

const Delivery = (props) => {
  
  const { delivery, roadmap } = props;
  const location = useLocation();
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  // Valeur possible : yes, no, pending
  const isDeliveryDone = delivery.done;

  const handleAccordionToggle = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  const translatePrestationType = (prestationType) => {
    const translationMap = {
      mealtray: "Plateaux-repas",
      caterer: "Traiteur",
      breakfast: "Petit-déjeuner"
    };
    return translationMap[prestationType] || prestationType;
  };

  const formatPhoneNumber = (phone) => {
    return phone.replace(/\D/g, '').slice(-10);
  };

  const hasUnusualRecoveryDate = delivery.recovery
    && isUnusualRecoveryDate(delivery.delivery.delivery_date, delivery.delivery.recovery_date);

  return (
    <Content>
      <Card key={"D"+delivery.id}>
        <Accordion.Toggle as={Card.Header} variant="link" eventKey={"D" + delivery.id} onClick={handleAccordionToggle} style={{opacity: isDeliveryDone ? "0.5" : "1",  borderLeft: delivery.recovery ? "#e3a7ff 5px solid" : "lightblue 5px solid"}}>
          <Row>
            <Col xs={8}>
              <FontAwesomeIcon icon={isAccordionOpen ? faCaretUp : faCaretDown} /> <b>{delivery?.delivery?.company ? delivery?.delivery?.company : "Société : NC"}</b><small> - {delivery.delivery.lastname ? delivery.delivery.lastname : "Nom : NC"}</small>
            </Col>
            <Col className="text-right" xs={4}>
              {hasUnusualRecoveryDate && (
                <Badge variant="warning" className="mr-1">
                  <FontAwesomeIcon icon={faExclamationTriangle} /> Pas le lendemain
                </Badge>
              )}
              {isDeliveryDone
                ?
                  <Badge variant="success">{delivery.recovery ? "RECUP "+delivery?.delivery?.info?.numbering : "LIV "+delivery?.delivery?.info?.numbering} <FontAwesomeIcon icon={faCheck} /></Badge>
                :
                  <Badge variant="danger">{delivery.recovery ? "RECUP "+delivery?.delivery?.info?.numbering : "LIV "+delivery?.delivery?.info?.numbering} <FontAwesomeIcon icon={faTimes} /></Badge>
              }
            </Col>
          </Row>
          
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={"D"+delivery.id}>
          <Card.Body>
            <div>
              <Row noGutters>
                <Col xs={1}>
                  <FontAwesomeIcon icon={faMapPin} />
                </Col>
                <Col xs={11}>
                  {delivery.delivery.street_number} {delivery.delivery.street ? delivery.delivery.street : "Rue : NC, "}<br/>
                  {delivery.delivery.postal_code ? delivery.delivery.postal_code : "Code postal : NC, "} {delivery.delivery.city ? delivery.delivery.city : "Ville : NC"}<br/>
                  {delivery.delivery.address_complement}
                </Col>
              </Row>
              <Row noGutters>
                <Col xs={1}>
                <FontAwesomeIcon icon={faUser} />
                </Col>
                <Col xs={11}>
                  {delivery.delivery.firstname ? delivery.delivery.firstname : "Prénom : NC, "} {delivery.delivery.lastname ? delivery.delivery.lastname : "Nom : NC"} / 
                  {delivery.delivery.phone ? <a href={`tel:${formatPhoneNumber(delivery.delivery.phone)}`}>{formatPhoneNumber(delivery.delivery.phone)}</a> : "NC"}
                  {delivery.delivery.phone_secondary &&
                    <>
                      <span className="mx-1">/</span>
                      <a href={`tel:${formatPhoneNumber(delivery.delivery.phone_secondary)}`}>{formatPhoneNumber(delivery.delivery.phone_secondary)}</a>
                    </>
                  }
                </Col>
              </Row>
              <hr/>
              <Row className="text-center align-items-center" noGutters>
                <Col xs={3} style={{borderRight: '1px solid #ddd'}}>
                  {delivery.recovery ?
                    <small>{translatePrestationType(delivery.delivery.prestation_type)}<br/>
                    {delivery.delivery.info.numbering} du {moment(delivery.delivery.delivery_date).format("D/M/Y")}<br/>{delivery.delivery.person} pers</small>
                    :
                    <small>{translatePrestationType(delivery.delivery.prestation_type)}<br/>
                    {delivery.delivery.person} pers</small>
                  }
                </Col>
                <Col xs={6} style={{borderRight: '1px solid #ddd'}}>

                  {delivery.recovery ?
                    <small className={hasUnusualRecoveryDate ? "recovery-date-unusual" : undefined}>
                    {hasUnusualRecoveryDate && (
                      <>
                        <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
                      </>
                    )}
                    Récup. prévue :<br/>
                    <b>{delivery.delivery.recovery_date != null ? moment(delivery.delivery.recovery_date).format("DD/MM/YYYY") : "NC"}</b>
                    {hasUnusualRecoveryDate && (
                      <>
                        <br/>
                        <span className="recovery-date-unusual-hint">
                          Livraison le {moment(delivery.delivery.delivery_date).format("DD/MM/YYYY")} — pas le lendemain
                        </span>
                      </>
                    )}
                    {(delivery.delivery.recovery_start_at || delivery.delivery.recovery_end_at) && (
                      <>
                        {" "}
                        {delivery.delivery.recovery_start_at ? moment(delivery.delivery.recovery_start_at).format("HH:mm") : "?"}
                        {" – "}
                        {delivery.delivery.recovery_end_at ? moment(delivery.delivery.recovery_end_at).format("HH:mm") : "?"}
                      </>
                    )}
                    {(() => {
                      // Thermos à récupérer : "Thermos : 3 à 3L / 4 à 6L"
                      // (capacité = nom sans le préfixe "Thermos"). Identifiés par
                      // nom + matériel marqué "à récupérer".
                      const materials = delivery?.delivery?.info?.materials || [];
                      const thermos = materials
                        .filter((m) => m.is_to_collect && /thermos/i.test(m.name || ""))
                        .map((m) => {
                          const qty = m.recovered_quantity != null ? m.recovered_quantity
                            : m.delivered_quantity != null ? m.delivered_quantity
                            : m.quantity != null ? m.quantity
                            : m.auto_generated_quantity;
                          const capacity = (m.name || "").replace(/^thermos\s*/i, "").trim() || (m.name || "");
                          return { capacity, qty: Number(qty) || 0 };
                        })
                        .filter((m) => m.qty > 0);
                      if (thermos.length === 0) return null;
                      return (
                        <><br/>Thermos : {thermos.map((m) => `${m.qty} à ${m.capacity}`).join(" / ")}</>
                      );
                    })()}
                    </small>
                  :
                    <small>Liv : {delivery.delivery.arrived_at_start ? moment(delivery.delivery.arrived_at_start).format("HH:mm") : "NC"} et {delivery.delivery.arrived_at_end ? moment(delivery.delivery.arrived_at_end).format("HH:mm") : "NC"}<br/>
                    Début : { delivery.delivery.start_at ? moment(delivery.delivery.start_at).format("HH:mm") : "NC"}</small>
                  }
                </Col>
                <Col xs={3}>
                  <small>{delivery.delivery.blanket ? "Avec nappe" : "Sans nappe"}</small>
                  <br/>
                  {delivery?.delivery?.service && 
                    <small>Avec service</small>
                  }
                </Col>
              </Row>
              <hr/>
              {delivery.recovery && delivery.delivery.recover_information ?
                <Row noGutters>
                  <Col xs={1}>
                    <small><FontAwesomeIcon icon={faComment} /></small>
                  </Col>
                  <Col xs={11}>
                    <small>{delivery.delivery.recover_information}</small>
                  </Col>
                </Row>
                :
                  delivery.recovery == false && delivery.delivery.delivery_information
                ?
                  <Row noGutters>
                    <Col xs={1}>
                      <small><FontAwesomeIcon icon={faComment} /></small>
                    </Col>
                    <Col xs={11}>
                      <small>{delivery.delivery.delivery_information}</small>
                    </Col>
                  </Row>
                :
                  null
              }
              {delivery.delivery.info.grouped_order_id ?
                <Link to={`/companion/tournee/${roadmap.id}/${delivery.id}/detail${location.search}`} style={{ textDecoration: 'none' }}>
                  {isDeliveryDone ? 
                    <Button variant="secondary" className="mt-3" block>
                      {delivery.recovery ? "Modifier récupération faite" : "Modifier livraison faite"}
                    </Button>
                  :  
                    <Button variant="dark" className="mt-3" size="lg" block>
                      {delivery.recovery ? "Voir cette récupération" : "Voir cette livraison"}
                    </Button>
                  }
                </Link>
              : 
                <p className="text-center" style={{ color: "red"}}>Ancien système, merci de migrer cette commande sur le nouveau système</p>
              }

            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Content>
  );
};

const Content = styled.div`
  margin: 10px 0;

  .recovery-date-unusual {
    display: block;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 4px;
    padding: 6px 4px;
    color: #856404;
  }

  .recovery-date-unusual-hint {
    font-size: 0.75rem;
    font-weight: bold;
  }
`

export default Delivery;
